'use client';

import clsx from 'clsx';
import { SelectItem } from '@ariakit/react';
import {
  DallasOptionItemProps,
  DallasOptionItemContent,
} from '../DallasOptionItem/DallasOptionItem';

import styles from '@ui/Dallas/Forms/DallasOptionItem/dallas-option-item.module.scss';

export default function DallasSelectItem<T extends string>({
  className,
  value,
  ...contentProps
}: DallasOptionItemProps<T>) {
  return (
    <SelectItem className={clsx(className, styles.root)} value={value}>
      <DallasOptionItemContent {...contentProps} />
    </SelectItem>
  );
}
